import React from 'react'
import styled from "styled-components";
import Check from '../../../../static/check.svg'
import Image from '../../../../basic/image'
import {withState} from 'recompose'
import CustomizedSwiper from '../../../../basic/CustomizedSwiper'
import TranslateText from 'src/text/modal';
import { v4 as uuid } from 'uuid';


const TextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  flex-direction: column;
  & > div {
    width: initial;
    margin-top: 20px;
  }
`

const Li = styled.li`
  font-size: 16px !important; 
  position: relative;
  text-align: center;
`
const CharacteristicsContainer = styled.div`
  position: relative;
  ${props => !props.readFull ? `&:after{
    content: '';
    box-shadow: 0px 2px 10px 10px rgba(255,255,255,0.8);
    position: absolute;
    bottom: 0;
    width: 100%;
    left: 0;
    z-index: 10;
}` : ""};
  
`

function CategoryText({characteristics, advantages, readFull, setReadFull}) {
  return (
    <TextContainer>
      {
        characteristics &&
        <div style={{textAlign: 'center',}}>
          <CharacteristicsContainer
            readFull={readFull}
            style={{
              fontSize: 16,

              ...(!readFull && {
                height: ((1.15 * 6 * 16) + (20 * 1.15) + 40),
                overflow: 'hidden',
              }),
            }}
          >
            <div
              style={{
                fontSize: 20,
                fontWeight: 600,
                textAlign: 'center',
                marginBottom: 40,
              }}
            >
              <TranslateText id="catalogue__main_characteristics" place="bottom" />
            </div>
            <TranslateText
              id={characteristics}
              useHtml
              controls={['ul']}
              place="top"
            />
          </CharacteristicsContainer>

          <div
            onClick={() => {
              setReadFull(!readFull)
            }}
            style={{
              fontSize: 20,
              marginTop: 15,
              color: 'rgb(23,61,176)',
              cursor: 'pointer',
            }}
          >
            {!readFull ?
              <TranslateText id="catalogue_characteristics__read_more" place="bottom" key={uuid()} />
              :
              <TranslateText id="catalogue_characteristics__close" place="bottom" key={uuid()} />
            }
          </div>
        </div>
      }

      {
        advantages &&
        <div>
          <div
            style={{
              fontSize: 20,
              fontWeight: 800,
              marginBottom: 20,
              textAlign: 'center',
            }}
          >
            <TranslateText id="catalogue__additional_benefits" place="bottom" />
          </div>
          <TranslateText
            id={advantages}
            controls={['ul']}
            useHtml
            place="bottom"
            render={(html) => {
              const regex = /\<li\>(.*)\<\/li\>/gm
              let match
              let advantagesList = []
              let isError = true
              try {
                while ((match = regex.exec(html)) != null) {
                  isError = false
                  advantagesList.push(match[1]);
                }
              } catch (e) {
                isError = true
              }
              if (isError) {
                advantagesList = [html]
              }
              return (
                <CustomizedSwiper
                  list={(advantagesList || []).map((a, i) => {
                    return (
                      <Li key={i}>
                        <Image
                          src={Check}
                          containerStyle={{
                            margin: 'auto',
                            width: '100%',
                          }}
                          style={{
                            margin: 'auto',
                            display: 'block',
                          }}
                        />
                        <div
                          style={{
                            marginTop: 15,
                          }}
                        >
                          {a}
                        </div>
                      </Li>
                    )
                  })}
                />
              )
            }}
          />
        </div>
      }
    </TextContainer>
  );
}

export default withState('readFull', 'setReadFull', false)(CategoryText)



// WEBPACK FOOTER //
// ./src/finwhale/common/category/text/Mobile.js